<template>
  <b-modal
      ref="modal-container"
      v-model="modalShow"
      size="xl"
      title="Help & Tournaments"
      :static="true"
      :lazy="true"
      hide-footer
      @shown="onShown"
  >
    <div class="modal-body" id="md-loader">
      <div class="row">
        <div class="col">
          <label class="form-label">Type</label>
          <b-form-select v-model="type" :options="typeOptions"></b-form-select>
        </div>
        <div class="col">
          <label class="form-label">Game folder</label>
          <div class="d-flex">
            <b-form-select v-model="gameFolder" :options="gameFolderOptions"></b-form-select>
            <button v-if="type !== null" class="btn btn-outline-primary ml-1" v-on:click="modalFolderShow = true"><i class="fa fa-plus"></i></button>
            <b-modal
                v-model="modalFolderShow"
                :title="`Add ${typeName} folder`"
                :static="true"
                :lazy="true"
                @show="onModalFolderShow"
                hide-footer
            >
              <div class="d-flex">
                <b-input v-model="newGameFolderName"></b-input>
                <button class="btn btn-success ml-3" v-on:click="addNewGameFolder">Add</button>
              </div>
            </b-modal>
          </div>
        </div>
        <div class="col">
          <label class="form-label">Language</label>
          <b-form-select v-model="lang" :options="langOptions"></b-form-select>
        </div>
        <div class="col d-flex align-items-end">
          <button class="btn btn-primary" :disabled="isLoading || !lang || !gameFolder || !type" v-on:click="loadMD">Show</button>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
            <textarea placeholder="Empty content" ref="mdEditor" v-model="text"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <button class="btn btn-default" v-on:click="hide">Close</button>
          <button :disabled="isLoading || !lang || !gameFolder || !type" class="btn btn-success pull-right" v-on:click="saveMD">Save</button>
        </div>
      </div>

    </div>
  </b-modal>
</template>

<script>
import SimpleMDE from "simplemde/src/js/simplemde"

function upFL(str) {
  const arr = str.split("-");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(" ");
}

export default {
  data() {
    return {
      modalShow: false,
      modalFolderShow: false,
      mdEditor: null,
      text: null,
      type: null,
      gameFolder: null,
      lang: null,
      isLoading: false,
      newGameFolderName: null
    }
  },
  props: ['languages'],
  methods: {
    addNewGameFolder() {
      if (this.isLoading) {
        return;
      }

      let loadingInstance = this.$veLoading({
        target: document.querySelector("#md-loader"),
        name: "wave",
      });
      this.isLoading = true;
      loadingInstance.show();

      this
          .$http({
            url: '/api/v1/localization/help-and-tournaments/folders',
            method: 'POST',
            data: {
              type: this.type,
              gameFolder: this.newGameFolderName
            }
          })
          .then(() => {
            this.newGameFolderName = null
            this.modalFolderShow = false
            this.$store.dispatch('helpFolders/loadList');
            this.$toastr.s("Folder created");
          })
          .catch((err) => {
            console.log(err.response);
            this.$toastr.e(err.response.data.message);
          })
          .finally(() => {
            this.isLoading = false;
            loadingInstance.close();
          })

    },
    onModalFolderShow() {
        this.newGameFolderName = null
    },
    show() {
      this.type = this.lang = this.gameFolder = null;
      this.modalShow = true;
    },
    hide() {
      this.modalShow = false;
    },
    onShown() {
      this.mdEditor = new SimpleMDE({element: this.$refs.mdEditor, toolbar: false, spellChecker: false});
    },
    loadMD() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#md-loader"),
        name: "wave",
      });
      this.isLoading = true;
      loadingInstance.show();

      this
          .$http({
            url: '/api/v1/localization/help-and-tournaments/' + this.type + '/' + this.gameFolder + '/' + this.lang + '.md',
            method: 'GET',
          })
          .then((resp) => {
            this.text = resp.data
            this.mdEditor.value(resp.data);
          })
          .catch((err) => {
            console.log(err);
            this.text = ''
            this.mdEditor.value('');
            this.$toastr.i('File not found');
          })
          .finally(() => {
            this.isLoading = false;
            loadingInstance.close();
          })
    },
    saveMD() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#md-loader"),
        name: "wave",
      });
      this.isLoading = true;
      loadingInstance.show();

      this
          .$http({
            url: '/api/v1/localization/help-and-tournaments/' + this.type + '/' + this.gameFolder + '/' + this.lang + '.md',
            method: 'POST',
            data: this.mdEditor.value()
          })
          .then(() => {
            this.$toastr.s('Saved');
          })
          .catch((err) => {
            console.log(err);
            this.$toastr.e('Save error');
          })
          .finally(() => {
            this.isLoading = false;
            loadingInstance.close();
          })
    }
  },
  computed: {
    typeName() {
      if (this.type === null) {
        return '';
      }

      return upFL(this.type)
    },
    typeOptions() {
      let types = [];
      this.$store.getters['helpFolders/list'].forEach((item) => {
        if (types.includes(item.type)) {
          return;
        }
        types.push(item.type)
      })

      return types
          .sort()
          .map((item) => {
            return {value: item, text: upFL(item)}
          })
    },
    langOptions() {
      return this.languages.map((lang) => {
        return {value: lang.code, text: lang.name}
      })
    },
    gameFolderOptions() {
      return this.$store.getters['helpFolders/list']
          .filter((item) => {
            return item.type === this.type
          })
          .sort((a, b) => {
            return a.gameFolder > b.gameFolder ? 1 : -1;
          })
          .map((item) => {return {value: item.gameFolder, text: upFL(item.gameFolder)}});
    }
  },
  async mounted() {
    await this.$store.dispatch('helpFolders/loadList');
  }
}
</script>
